module.exports = __webpack_public_path__ + "img/sun_rise.97da9503.svg";